import React from 'react';
import { GatsbyLink } from './glink';
export default function patchButtonBaseComponent(BaseButtonComponent) {
    return React.forwardRef((props, ref) => {
        const { to, ...buttonProps } = props;
        const component = to ? GatsbyLink : undefined;
        return (React.createElement(BaseButtonComponent, { component: component, ref: ref, to: to, ...buttonProps }));
    });
}
